import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { TopicRecordList } from "web/components/Topic"
import { useAsset } from "web/hooks/data"
import React, { Suspense } from "react"

export default class AssetTopicRecordListController extends Controller {
  static values = {
    assetId: Number,
    topicName: String,
    basePath: String,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const AssetTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="asset"
          data={useAsset(this.assetIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <AssetTLOContextProvider>
                <ErrorBoundary>
                  <TopicRecordList
                    subjectType="asset"
                    subjectId={this.assetIdValue}
                    route={[{ key: this.topicNameValue }]}
                    rootUrl={this.basePathValue}
                    canRedirectToRootUrl={false}
                  />
                </ErrorBoundary>
              </AssetTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
